import React from "react";
import { Link, LinkProps, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SUPPORTED = ["fr", "de", "en", "it", "pt", "es"];

/**
 * A Link component that automatically prefixes paths with the user's preferred language.
 * Priority: i18n.language > URL lang param > "fr".
 * Usage: <LocalizedLink to="/horses">...</LocalizedLink>
 */
const LocalizedLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...props }, ref) => {
    const { lang: urlLang } = useParams<{ lang: string }>();
    const { i18n } = useTranslation();

    const i18nLang = i18n.language?.toLowerCase().split("-")[0];
    const preferred =
      (i18nLang && SUPPORTED.includes(i18nLang) && i18nLang) ||
      (urlLang && SUPPORTED.includes(urlLang) && urlLang) ||
      "fr";

    const localizedTo =
      typeof to === "string" && to.startsWith("/")
        ? `/${preferred}${to === "/" ? "" : to}`
        : to;

    return <Link ref={ref} to={localizedTo} {...props} />;
  }
);

LocalizedLink.displayName = "LocalizedLink";

export default LocalizedLink;
